import { createSlice } from "@reduxjs/toolkit";
import instance from "../../../api/api.js";

export const fectchProprietesVenteTerrain = (payload) => async (dispatch) => {
  dispatch(changeIsLoading(true));
  try {
    console.log("fectchProprietesVenteTerrain", payload);
    const data = {
      annee: !payload.date_debut ? payload : null,
      date_debut: payload.date_debut,
      date_fin: payload.date_fin,
    };
    const response_prevision = await instance.post(
      "previsionProprietesVenteTerrain",
      data
    );
    const response_revenu = await instance.post(
      "revenuProprietesVenteTerrain",
      data
    );
    const response_recouvrement = await instance.post(
      "recouvrementProprietesVenteTerrain",
      data
    );
    const response_terrain_indisponible = await instance.post(
      "inactifProprietesVenteTerrain",
      data
    );
    console.log(
      "response_terrain_indisponible",
      response_terrain_indisponible?.data.data
    );
    console.log("response_revenu1", response_revenu?.data.data);
    console.log("response_recouvrement", response_recouvrement?.data.data);

    response_prevision?.data.data.forEach((element) => {
      response_revenu?.data.data.forEach((item) => {
        if (item.mois === element.mois) {
          item.previsions = element.totalPrevision;
        }
      });
    });
    response_recouvrement?.data.data.forEach((element) => {
      response_revenu?.data.data.forEach((item) => {
        if (item.mois === element.mois) {
          item.recouvrement = element.totalRecouvrement;
        }
      });
    });

    console.log("response_prevision", response_prevision?.data.data);
    console.log("response_revenu2", response_revenu?.data.data);

    const statistiqueData = response_revenu?.data.data.map((item) => {
      return {
        month: item.mois,
        previsions: item.previsions,
        revenus: item.totalRevenu,
        recouvrement: item.recouvrement,
      };
    });
    const statistiqueDataBien = response_revenu?.data.data.map((item) => {
      return {
        month: item.mois,
        terrains: item.totalBiens,
      };
    });

    const statistiqueDataBienIndisponible =
      response_terrain_indisponible?.data.data.map((item) => {
        return {
          month: item.mois,
          terrain_vente_indisponible: item.totalBiens,
        };
      });
    console.log("statistiqueDataProprieteVenteMaison", statistiqueData);
    dispatch(
      fetch_Statistiques_Prevision_revenus_recouvrement({
        data: statistiqueData,
        terrain_en_vente: statistiqueDataBien,
        terrain_indisponible: statistiqueDataBienIndisponible,
      })
    );
  } catch (error) {
    console.log();
  }
  dispatch(changeIsLoading(false));
};

export const proprietesVenteTerrainReducer = createSlice({
  name: "ProprietesVenteTerrain",
  initialState: {
    data: [],
    terrain_en_vente: [],
    terrain_en_vente_indisponible: [],
    isloading: false,
  },
  reducers: {
    fetch_Statistiques_Prevision_revenus_recouvrement: (state, action) => {
      return {
        ...state,
        terrain_en_vente: action.payload.terrain_en_vente,
        terrain_en_vente_indisponible: action.payload.terrain_indisponible,
        data: action.payload.data,
      };
    },
    changeIsLoading: (state, action) => {
      return { ...state, isloading: action.payload };
    },
  },
});

export const {
  fetch_Statistiques_Prevision_revenus_recouvrement,
  changeIsLoading,
} = proprietesVenteTerrainReducer.actions;
export default proprietesVenteTerrainReducer.reducer;
